module.exports = __webpack_public_path__ + "static/media/link.daefd42c.svg";